export default "__VITE_ASSET__COFFnxrD__"